import { HttpResponse } from 'shell/models/http-response';
import { AxiosResponse } from 'axios';
import { TypeOperationData } from 'shell/models/type-operation';
import { FormTypeOperationVM } from 'practice/components/type-operation/form';

export const typeOperationResponseTransformer = (
  response: AxiosResponse<HttpResponse<TypeOperationData>>
): FormTypeOperationVM => {
  const { data } = response;
  const item = data.payload;
  return {
    code: item.key?.tipoOperazione || '',
    description: item.descrizioneTipoOperazione || '',
    descriptionBrief: item.descrizioneBreveTipoOperazione || '',
    practice: item.key?.tipoPratica || '',
    printDoc: item.flagStampaDocumento || '',
    typeDocument: item.codiceTipoDocumento || '',
    codeMovement: item.codiceMotivo || '',
    inUse: item.flagOperazioneInUso || '',
  };
};
